<template>
  <section class="container-fluid Jumbotron">
    <header class="container TitleCard">
      <div class="row Section">
        <div class="col-md-10 col-lg-8">
          <h1 class="TitleCard-title">Rent a Cutting-Edge <span class="Highlight Highlight--emerald Highlight--tall">Touch Table</span> or <span class="Highlight Highlight--emerald Highlight--tall">Interactive Display</span></h1>
        </div>
        <div class="col-md-7">
          <p class="TitleCard-subtitle">Engage the audience at your next event or trade show by providing a truly memorable interactive experience with Ideum’s multitouch tables and displays.</p>
        </div>
      </div>
    </header>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Jumbotron {
  background-image: url('./../assets/images/ideum-jumbo--1900.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  height: 100vh;
  min-height: 100vh;
  &::after {
    background-color: $colorPlum;
    content: '';
    opacity: .8;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.TitleCard {
  color: $colorWhite;
  margin-bottom: 3em;
  z-index: 1;
}

.TitleCard-subtitle {
  font-size: 1.25em;
  letter-spacing: .5px;
  @media screen and (max-width: $grid-sm) {
    font-size: 1em;
  }
}

.TitleCard-title {
  letter-spacing: .1rem;
  margin-bottom: .75em;
  @media screen and (max-width: $grid-xl) {
    font-size: 3.75em;
  }
  @media screen and (max-width: $grid-lg) {
    font-size: 3.5em;
  }
  @media screen and (max-width: $grid-md) {
    font-size: 2.75em;
  }
  @media screen and (max-width: $grid-sm) {
    font-size: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Jumbotron.vue